const SERP_SESSION_TOKEN_LS_KEY = "isp_session_1";
const SESSION_TOKEN_LS_KEY = "fast-session-token";
const SESSION_TOKEN_LIFE = 1800;
export default function getSessionToken() {
    var _a;
    const sessionLC = (_a = getSERPSession()) !== null && _a !== void 0 ? _a : localStorage.getItem(SESSION_TOKEN_LS_KEY);
    const now = Math.round(Date.now() / 1000);
    if (sessionLC) {
        const currentSession = JSON.parse(sessionLC);
        if (now - currentSession.lastActive >= SESSION_TOKEN_LIFE) {
            return withLocalStorage({
                lastActive: now,
                start: now,
            });
        }
        else {
            return withLocalStorage({
                lastActive: now,
                start: currentSession.start
            });
        }
    }
    else {
        return withLocalStorage({
            lastActive: now,
            start: now,
        });
    }
}
function getSERPSession() {
    if (SERP_SESSION_TOKEN_LS_KEY in localStorage) {
        const session = JSON.parse(localStorage.getItem(SERP_SESSION_TOKEN_LS_KEY));
        return JSON.stringify({
            lastActive: session.last_active,
            start: session.start,
        });
    }
    return null;
}
function withLocalStorage(token) {
    localStorage.setItem(SERP_SESSION_TOKEN_LS_KEY, JSON.stringify({
        last_active: token.lastActive,
        start: token.start
    }));
    localStorage.setItem(SESSION_TOKEN_LS_KEY, JSON.stringify(token));
    return token;
}
//# sourceMappingURL=getSessionToken.js.map